import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const splitPaymentCardSectionStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.medium,
    fontFamily: theme.typography.fontFamily,
  } as CSSProperties,

  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing.small,
  } as CSSProperties,

  title: {
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.label,
    margin: 0,
  } as CSSProperties,

  helperText: {
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.normal,
    color: theme.colors.subtitle,
    margin: 0,
  } as CSSProperties,

  installmentTitle: {
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.label,
    margin: 0,
  } as CSSProperties,

  installmentsPendingHint: {
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.sm,
    color: theme.colors.subtitle,
    backgroundColor: theme.colors.palette.lightBlue275,
    borderRadius: theme.radius.sm,
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    margin: 0,
  } as CSSProperties,

    carouselContainer: {
      paddingLeft: theme.spacing.medium,
  } as CSSProperties,

  carouselContained: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
  } as CSSProperties,

  contained: {
    paddingLeft: theme.spacing.medium,
    paddingRight: theme.spacing.medium,
    boxSizing: 'border-box',
    maxWidth: '100%',
    minWidth: 0,
  } as CSSProperties,

  dividerLine: {
    display: 'block',
    width: '100%',
    height: 1,
    backgroundColor: theme.colors.palette.grey300,
  } as CSSProperties,

  dividerAdd: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    flexShrink: 0,
    border: 'none',
    background: 'none',
    padding: 0,
    cursor: 'pointer',
    color: theme.colors.button.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.bold,
    whiteSpace: 'nowrap',
  } as CSSProperties,
};
